import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import OnboardingForm from './Forms/OnboardingForm'


@inject('adminStore')

@observer
class Onboarding extends Component {

  componentDidMount() {
    this.props.adminStore.getApplicationById(this.props.match.params.uid)
  }

  render() {

    const { isApplication, application } = this.props.adminStore

    if (!isApplication)
      return null

    return (
      <div>
        <div>
          <OnboardingForm application={application}/>
        </div>
      </div>
    )
  }
}

export default Onboarding



// WEBPACK FOOTER //
// /src/components/admin/Onboarding.js